/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseExternalProductId } from './courseExternalProductId';
import type { CourseSegments } from './courseSegments';
import type { CourseState } from './courseState';
import type { CourseStateChangedAt } from './courseStateChangedAt';
import type { CourseModuleSummary } from './courseModuleSummary';

/**
 * course model
 */
export interface Course {
  title: string;
  description?: string;
  ects?: number;
  language?: string;
  externalProductId?: CourseExternalProductId;
  segments?: CourseSegments;
  id: string;
  state?: CourseState;
  isDeprecated?: boolean;
  stateChangedAt?: CourseStateChangedAt;
  modules?: CourseModuleSummary[];
}
